import { render, staticRenderFns } from "./grantListInfo.vue?vue&type=template&id=62bf0b69&scoped=true"
import script from "./grantListInfo.vue?vue&type=script&lang=js"
export * from "./grantListInfo.vue?vue&type=script&lang=js"
import style0 from "./grantListInfo.vue?vue&type=style&index=0&id=62bf0b69&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bf0b69",
  null
  
)

export default component.exports